import {getTranslationDict} from "./DataGetter";
import {Languages} from "../enums/Languages";

class TranslateService {
    constructor(){
        this.dict = [];
    }

    loadTranslates = async () => {
        Languages.forEach((language) => {
            this.dict[language] = JSON.parse(sessionStorage.getItem('translates-' + language));
        });

        if(this.dict['en'] === undefined || this.dict['en'] === null){
            const response = await getTranslationDict();
            const json = await response.json();
            for(let key in json){
                sessionStorage.setItem('translates-'+key, JSON.stringify(json[key]));
                this.loading = false;
                this.dict[key] = json[key];
            }

        }
    };

   getSlug(slug, lang) {
        if(Object.values(this.dict).length === 0 ){
            this.loadTranslates();
        }

        if (this.dict[lang] !== undefined && this.dict[lang][slug] !== undefined ) {
            return this.dict[lang][slug];
        } else {
            console.log(slug);
            return slug;
        }
    }
}

export default TranslateService;
